var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    "row justify-content-center",
    !_vm.belowTable && "mb-3"]},[(_vm.paging.totalCount > _vm.paging.pageSize)?_c('b-pagination',_vm._b({staticClass:"mr-2",attrs:{"total-rows":_vm.paging.totalCount,"per-page":_vm.paging.pageSize},model:{value:(_vm.paging.pageNumber),callback:function ($$v) {_vm.$set(_vm.paging, "pageNumber", $$v)},expression:"paging.pageNumber"}},'b-pagination',!_vm.small ? {
            align: 'left',
            limit: 8,
            firstNumber: true,
            lastNumber: true
        } : {
            align:'center'
        },false)):_vm._e(),_c('b-form-select',{staticClass:"w-10 mt-3",attrs:{"options":_vm.paging.pageSizeOptions},model:{value:(_vm.paging.pageSize),callback:function ($$v) {_vm.$set(_vm.paging, "pageSize", $$v)},expression:"paging.pageSize"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }